import React from 'react';
import './AdminTableUsersMain.scss';

import { getAllUsers } from '../../../adminUserSlice';

//import { refreshToken } from '../../../../Authorization/authSlice';
import TableUsers from './TableUsers/TableUsers';
//import { unwrapResult } from '@reduxjs/toolkit'

const AdminTableUsersMain = (props) => {
   
    const {dispatch} = props;
 /*   const ongetAllUsers = () => {
        dispatch(getAllUsers());
    }
    */
   /*
    const ongetAllUsers = async () => {
        try {
        //  const answer = await dispatch(getAllUsers()).unwrap().then(res =>
        //    console.log(res));
        const answer = await dispatch(getAllUsers()).then(unwrapResult)
        .then((originalPromiseResult) => {
          console.log(originalPromiseResult);
          return originalPromiseResult;
        })
          //const answer = await dispatch(getAllUsers()).unwrap();
          console.log(answer);
          if (answer === 401) {
            console.log("REFRESH NOW")
            const answer2 = await dispatch(refreshToken());
            console.log(answer2);
            if (answer2) {
              console.log("START GET DATA AFTER REFRESH")
              dispatch(getAllUsers());
            }
      
          }
        } catch (e) {
          console.log(e);
        }
      }
*/

  const ongetAllUsers = () => {
    dispatch(getAllUsers());
  }

        return (
            
            <div className="AdminTableUsersMain">
                   <h3>Список пользователей</h3>
                   <button id='refresh' onClick={ongetAllUsers}></button>
                   <div id="all-users-container">
                    
                   </div>
                  <TableUsers  adminUsersState = {props.adminUsersState.data}/>
                    
                    



                
            </div>
        )
    }

export default AdminTableUsersMain;